import pdfJsUrl from "pdfjs-dist/legacy/build/pdf.min.mjs?url";
import pdfJsWorkerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";

type PdfJs = typeof import("pdfjs-dist");

let pdfJs: Promise<PdfJs> | null = null;

/**
 * The IIFE bundle cannot be split into chunks (a regular dynamic import would inline pdf.js into main.js),
 * so Vite emits pdf.js and its worker as hashed assets next to main.js and the library is imported by URL.
 */
export function loadPdfJs(): Promise<PdfJs> {
	pdfJs ??= (async () => {
		const module = await import(/* @vite-ignore */ pdfJsUrl) as PdfJs;
		module.GlobalWorkerOptions.workerSrc = pdfJsWorkerUrl;
		return module;
	})().catch((error: unknown) => {
		// allow a retry on the next preview instead of caching the failed import
		pdfJs = null;
		throw error;
	});
	return pdfJs;
}

/** Appends the pages of all PDFs into a single PDF, so they can be printed at once. */
export async function mergePdfs(documents: Uint8Array[]): Promise<Uint8Array> {
	const pdfJs = await loadPdfJs();
	// pdf.js transfers the buffers to its worker, so it gets copies
	const loadingTask = pdfJs.getDocument({data: documents[0].slice()});
	try {
		const base = await loadingTask.promise;
		return await base.extractPages(documents.map((data, index) => ({document: index === 0 ? null : data.slice()})));
	} finally {
		void loadingTask.destroy();
	}
}
